var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceivesACopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 16C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V14C18 14.55 17.8042 15.0208 17.4125 15.4125C17.0208 15.8042 16.55 16 16 16H2ZM2 14H16V2H2V14ZM4 11H7C7.28333 11 7.52083 10.9042 7.7125 10.7125C7.90417 10.5208 8 10.2833 8 10V9H6.5V9.5H4.5V6.5H6.5V7H8V6C8 5.71667 7.90417 5.47917 7.7125 5.2875C7.52083 5.09583 7.28333 5 7 5H4C3.71667 5 3.47917 5.09583 3.2875 5.2875C3.09583 5.47917 3 5.71667 3 6V10C3 10.2833 3.09583 10.5208 3.2875 10.7125C3.47917 10.9042 3.71667 11 4 11ZM11 11H14C14.2833 11 14.5208 10.9042 14.7125 10.7125C14.9042 10.5208 15 10.2833 15 10V9H13.5V9.5H11.5V6.5H13.5V7H15V6C15 5.71667 14.9042 5.47917 14.7125 5.2875C14.5208 5.09583 14.2833 5 14 5H11C10.7167 5 10.4792 5.09583 10.2875 5.2875C10.0958 5.47917 10 5.71667 10 6V10C10 10.2833 10.0958 10.5208 10.2875 10.7125C10.4792 10.9042 10.7167 11 11 11Z",
    fill: "#265183"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceivesACopy);
export default __webpack_public_path__ + "static/media/receives_a_copy.f19db60561ecc5804150c1143bc4b4df.svg";
export { ForwardRef as ReactComponent };